import { TrackingTrackingModelsAnalyticsDownloadDailySummary } from "melco-shared-logic";

export const useDownloadDetail = (
  selectedUserId: string,
  reportsRawData:
    | TrackingTrackingModelsAnalyticsDownloadDailySummary[]
    | undefined,
  selectedRowType: string,
  selectedRowProductCode: string
) => {
  let DownloadDetailData: TrackingTrackingModelsAnalyticsDownloadDailySummary[] =
    [];
  if (reportsRawData) {
    for (let rData of reportsRawData) {
      if (
        String(rData.id) === String(selectedUserId) &&
        String(rData.product_code) === String(selectedRowProductCode) &&
        String(rData.type) === String(selectedRowType)) {
        DownloadDetailData.push(rData);
      }
    }
  }

  return { DownloadDetailData };
};
